import { render, staticRenderFns } from "./Exception.vue?vue&type=template&id=2d9b359c&scoped=true&"
import script from "./Exception.vue?vue&type=script&lang=js&"
export * from "./Exception.vue?vue&type=script&lang=js&"
import style0 from "./Exception.vue?vue&type=style&index=0&id=2d9b359c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9b359c",
  null
  
)

export default component.exports